/*
 MSmsWeb

 Tresc polityki prywatnosci dla mSmsWeb 
  
 historia: 
  PM 2021-09-07 - start
*/

import * as React from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import DaneZbierane from './common/DaneZbierane';
import UdostepnianieDanych from './common/UdostepnianieDanych';
import AdministratorDanych from './common/AdministratorDanych';
import PrzechowywanieDanych from './common/PrzechowywanieDanych';
import WycofywanieDanych from './common/WycofywanieDanych';
import './common/robotoItalic.css';

class MSmsWeb extends React.Component<WithStyles<typeof styles>, any> {

    //PM 2021-11-05
    //variant='body2'
    //poprawka DOM
    render() {
        const { classes } = this.props;

        return (
            <React.Fragment>
                <Typography variant='body2'><b>Uprawnienia aplikacji</b></Typography>
                <Typography variant='body2'>
                    Aplikacja mobilna może uzyskać dostęp do następujących uprawnień na urządzeniu mobilnym (wytłuszczoną czcionką oznaczone uprawnienia wrażliwe):
                </Typography>
                <Typography variant='body2'>- odczytu danych z pamięci zewnętrznej urządzenia,</Typography>
                <Typography variant='body2' className={classes.cursive}>m. in. w celu lokalnego odczytu logów (dzienników zdarzeń aplikacji),</Typography>
                <Typography variant='body2'>- zapisu danych do pamięci zewnętrznej urządzenia,</Typography>
                <Typography variant='body2' className={classes.cursive}>m. in. w celu tworzenia i zapisu do plików z logami,</Typography>
                <Typography variant='body2'>- odczytu stanu połączenia Wi-Fi,</Typography>
                <Typography variant='body2' className={classes.cursive}>
                    w celu sprawdzenia i informowania użytkownika o aktywnym połączeniu sieciowym oraz do zbierania danych technicznych w raportach awarii,
                </Typography>
                <Typography variant='body2'>- zmiany stanu połączenia Wi-Fi,</Typography>
                <Typography variant='body2' className={classes.cursive}>
                    do możliwości włączenia modułu Wi-Fi z poziomu aplikacji oraz opcjonalnej funkcji resetu połączenia,
                </Typography>
                <Typography variant='body2'>- instalacji pakietów aplikacji,</Typography>
                <Typography variant='body2' className={classes.cursive}>
                    do instalacji aktualizacji jeśli aplikacja była zainstalowana z innego źródła niż sklep z aplikacjami,
                </Typography>
                <Typography variant='body2'>- zapobieganie stanowi uśpienia,</Typography>
                <Typography variant='body2' className={classes.cursive}>jako opcjonalna funkcja pozwalająca na dłuższą pracę aplikacji przed jej optymalizacją,</Typography>
                <Typography variant='body2'><b>- wysyłania wiadomości sms,</b></Typography>
                <Typography variant='body2' className={classes.cursive}>
                    w celu wysyłki wiadomości sms z komunikatów otrzymanych przez serwer do klientów końcowych, jak i przekierowywania smsów adresowanych do klientów ale wysłanych na urządzenie, na którym zainstalowana jest aplikacja,
                </Typography>
                <Typography variant='body2'><b>- odbierania wiadomości sms i mms,</b></Typography>
                <Typography variant='body2' className={classes.cursive}>
                    w celu odczytania oraz przekierowywania wiadomości sms adresowanych do klientów ale wysłanych na urządzenie, na którym zainstalowana jest aplikacja,
                </Typography>
                <Typography variant='body2'><b>- odczytywania historii połączeń,</b></Typography>
                <Typography variant='body2' className={classes.cursive}>
                    w celu odczytania numeru dzwoniącego z historii połączeń w celu automatycznej wysyłki informacji, z jakim numerem (numerem klienta) powinien on się skontaktować zamiast numeru telefonu urządzenia, na którym zainstalowana jest aplikacja,
                </Typography>
                <Typography variant='body2'><b>- odczytywania stanu telefonu,</b></Typography>
                <Typography variant='body2' className={classes.cursive}>
                    w celu odczytania numeru telefonu identyfikującego urządzenie oraz statusu połączenia, w celu wysłania wiadomości do dzwoniącego, z jakim numerem (numerem klienta) powinien on się skontaktować zamiast numeru telefonu urządzenia, na którym zainstalowana jest aplikacja,
                </Typography>
                <Typography variant='body2'>
                    Wszystkie uprawnienia, jakie są nadane przez użytkowników dla aplikacji mobilne są widoczne w panelu ustawień dla danej aplikacji w danym urządzeniu mobilnym. Uprawnienia aplikacji mogą zostać odwołane przez zmianę ustawień na urządzeniu mobilnym, wyczyszczenie danych aplikacji bądź odinstalowanie samej aplikacji.
                </Typography>
                <br />
                <DaneZbierane sms />
                <br />
                <PrzechowywanieDanych sms />
                <br />
                <UdostepnianieDanych />
                <br />
                <WycofywanieDanych />
                <br />
                <AdministratorDanych />
            </React.Fragment>
        );
    }
}

const styles = () => ({
    cursive: {
        fontFamily: 'RobotoItalic'
    }
});

export default withStyles(styles)(MSmsWeb);
